import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import { formatMinutes } from "../../../views/PCW/pcwApi";
import { SHOP_CLOCKS } from "../../../views/PCW/shopClocks";
import WidgetFrame, { WidgetEmpty, WidgetStat } from "./WidgetFrame";

// A shop clock at a glance (PCW, or the Mill shop — catalog roles mirror each
// dashboard's gate, and the API also checks the x-user-id header
// server-side): who's punched in right now, plus hours and work orders over
// the last 7 days.
const startOfDaysAgo = (days) => {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() - (days - 1));
  return date;
};

const ShopClockWidget = ({ shopKey }) => {
  const shop = SHOP_CLOCKS[shopKey];
  const user = useSelector(selectUser);
  const [summary, setSummary] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!user?.id) return;
    shop.api
      .fetchSummary(user.id, { from: startOfDaysAgo(7).toISOString() })
      .then(setSummary)
      .catch(() => setFailed(true));
  }, [user?.id, shop]);

  return (
    <WidgetFrame title={shop.title} to={shop.path}>
      {summary ? (
        <div className="grid grid-cols-3 gap-2">
          <WidgetStat
            value={summary.openPunches.length}
            label="Punched in"
          />
          <WidgetStat
            value={formatMinutes(summary.totals.minutes)}
            label="Hours (7d)"
          />
          <WidgetStat
            value={summary.totals.workOrders}
            label="Work orders"
          />
        </div>
      ) : (
        <WidgetEmpty>
          {failed ? `Couldn't load ${shop.title}.` : "Loading hours…"}
        </WidgetEmpty>
      )}
    </WidgetFrame>
  );
};

const PCWWidget = () => <ShopClockWidget shopKey="pcw" />;
export const MillShopWidget = () => <ShopClockWidget shopKey="mill" />;

export default PCWWidget;
